import type { CSSProperties } from "react";

/** Match `AinaCameraDoubtFlow` — above LiveKit / AINA full-viewport layers. */
const AINA_STACKING_OVERLAY_Z = 10_000_000_000;

export const uploadQuestionIntroModalShellStyles: {
  overlay: CSSProperties;
  modal: CSSProperties;
  body: CSSProperties;
} = {
  overlay: { zIndex: AINA_STACKING_OVERLAY_Z },
  modal: {
    zIndex: AINA_STACKING_OVERLAY_Z + 1,
    backgroundColor: "transparent",
    boxShadow: "none",
    maxWidth: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  body: {
    justifyContent: "center",
    alignItems: "center",
  },
};
